import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isVip, setIsVip] = useState(null);
  const [checked, setChecked] = useState(false);

  const vipExemptPaths = ['/payment-success'];

  useEffect(() => {
    let cancelled = false;

    const verify = async () => {
      try {
        // Check auth
        await axios.get(`/api/auth/me`, { withCredentials: true });
        if (cancelled) return;
        setIsAuthenticated(true);

        // Check VIP status
        try {
          const subRes = await axios.get(`/api/payments/subscription-status`, { withCredentials: true });
          if (cancelled) return;
          setIsVip(subRes.data.is_vip);
        } catch {
          if (!cancelled) setIsVip(false);
        }
      } catch {
        if (!cancelled) {
          setIsAuthenticated(false);
          navigate('/login', { replace: true });
        }
      } finally {
        if (!cancelled) setChecked(true);
      }
    };

    verify();
    return () => { cancelled = true; };
  }, [navigate, location.pathname]);

  if (!checked) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) return null;

  if (!isVip && !vipExemptPaths.includes(location.pathname)) {
    navigate('/subscribe', { replace: true });
    return null;
  }

  return children;
};

export default ProtectedRoute;
